import appLocaleData from 'react-intl/locale-data/fa';
import faMessages from '../locales/fa_IR';

const FaLang = {
    messages: {
        ...faMessages
    },
    locale: 'fa-IR',
    data: appLocaleData
};
export default FaLang;